<template>
  <div class="base-carddraw">
    <div class="card-list">
      <div
        v-for="index in mValue.num"
        class="item"
        :key="index"
        @click="onStart"
      >
        <slot name="item" :item="mValue.bg || defaultBg"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseCarddraw',
  props: {
    draw: {
      type: Object,
      default: () => {}
    },
    turnsTime: {
      // 转动需要持续的时间(秒)
      default: 3
    }
  },
  data() {
    return {
      mValue: undefined,
      listValue: [],
      defaultBg:
        'https://cdn-tx-admin-test.3kwan.com/2023/07/12/b1680c9bde6f31f2de753181de9f391a.jpg'
    };
  },
  components: {},
  computed: {
    state() {
      return this.$store.state;
    }
  },
  watch: {
    draw: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.mValue = newVal;
      }
    }
  },
  methods: {
    onStart() {
      this.$emit('start-turns');
    },
    runAni() {
      this.$store.commit('OPEN_DIALOG', 'Effect');
      const turnsTime = this.turnsTime;
      setTimeout(() => {
        this.$store.commit('CLOSE_DIALOG', 'Effect');
      }, turnsTime * 1000);
      setTimeout(() => {
        this.$emit('end-turns');
      }, turnsTime * 1000 + 500);
    }
  }
};
</script>

<style lang="scss" scoped>
.card-list {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  .item {
    flex: 0 0 31%;
    margin-top: 20px;
  }
  img {
    display: block;
    width: 100%;
  }
}
</style>
